import { useEffect, useState } from "react";
import { RootState } from "../../redux/rootReducers";
import { connect } from "react-redux";
import ScheduledUpcomingInterviews from "../../components/ThinksToDo/ScheduledUpcomingInterviews";
import PendingInterviewApprovals from "../../components/ThinksToDo/PendingInterviewApprovals";
import {
  ApproveAndRejectRegularizePayloadType,
  GetJobClosureListPayloadType,
  GetRegularizeApprovalPendingListPayloadType,
  GetScheduledUpcomingInterviewsListPayloadType,
  GetUnApprovedInvoiceCountPayloadType,
  SendApprovalStatusPayloadType,
  SingleScheduledUpcomingInterviewsDeatilsPayloadType,
} from "../../commonTypes/thinksToDoTypes";
import {
  approveOrRejectRegularizeAction,
  getJobClosureListAction,
  getJobClosureRMListAction,
  getRegularizeApprovalPendingListAction,
  getScheduledUpcomingInterviewsList,
  getUnApprovedInvoiceCountListAction,
  resetJobClosureListForRM,
  resetRegularizeApprovalPendingList,
  resetScheduledUpcomingInterviewsList,
  resetThinksToDoError,
  resetThinksToDoMessage,
  resetThinksToDoStatusCode,
  resetThinksToDoSuccess,
  resetThinksToDoUpdateFetching,
  resetTotalCountRM,
  resetUnApprovedInvoiceCountData,
  resetUnApprovedInvoiceTotalCount,
  sendApprovalStatusAction,
  singleScheduledUpcomingInterviewsDetailsAction,
  updateRecruitmentTrackerAction,
} from "../../redux/thinksToDo";
import {
  AddScheduledUpcomingInterviewsDetailsType,
  ScheduledUpcomingInterviewsListType,
  SingleScheduledUpcomingInterviewsDetailsType,
  UnApprovedInvoiceCountDataListType,
} from "../../redux/thinksToDo/thinksToDoType";
import {
  currentDate,
  formatDate,
  reverseDate,
} from "../../utils/commonFunctions";
import FeedBackModal from "../../components/ThinksToDo/FeedBackModal";

import {
  CommonHeader,
  ErrorSuccessModal,
  Loader,
} from "../../components/commons";
import { resetSession } from "../../redux/auth";
import toast, { Toaster } from "react-hot-toast";
import { LoginResponseType } from "../../redux/auth/authTypes";
import {
  getApprovalListAction,
  resetApprovalList,
  resetHrmsError,
  resetHrmsMessage,
  resetHrmsSuccess,
} from "../../redux/hrms";
import { ApprovalListPayloadType } from "../../commonTypes/hrmsTypes";
import { ApprovalListType } from "../../redux/hrms/hrmsTypes";
import UpcomingCheckInSchedule from "../../components/ThinksToDo/UpcomingCheckInSchedule";
import {
  addCheckInScheduleFeedbackApiAction,
  addPerformanceEvaluationFeedbackAction,
  getCheckInScheduleListAction,
  getCheckInScheduleManagerViewListAction,
  getPerformanceEvaluationListAction,
  getSingleCheckInScheduleDetailsAction,
  getSinglePerformanceEvaluationDetailsAction,
  resetCheckInScheduleList,
  resetCheckInScheduleManagerViewList,
  resetMySpaceError,
  resetMySpaceMessage,
  resetMySpaceSuccess,
  resetPerformanceEvaluationList,
  resetSingleCheckInScheduleDetails,
  resetSinglePeDetailsList,
} from "../../redux/mySpace";
import {
  AddCheckInScheduleFeedbackPayloadType,
  GetCheckInScheduleListPayloadType,
  GetSingleCheckInScheduleDetailsPayloadType,
} from "../../commonTypes/mySpaceType";
import CheckInFeedBackModal from "../../components/ThinksToDo/CheckInFeedBackModal";
import UpcomingUsersCheckInSchedule from "../../components/ThinksToDo/UpcomingUsersCheckInSchedule";
import { useMenuCheck } from "../../customHooks/useMenuCheck";
import { GetCheckInDetailDataType } from "../../redux/mySpace/mySpaceTypes";
import ManagerPEform from "../../components/ThinksToDo/ManagerPEform";
import ManagerViewPEFormModal from "../../components/MySpace/PEFormModule/ManagerViewPEFormModal";
import { ImageDataType } from "../../commonTypes/fileManagerTypes";
import { BlobServiceClient } from "@azure/storage-blob";
import ManagerJobClosureRequests from "../../components/ThinksToDo/JobClosureModule/ManagerJobClosureRequests";
import JobClosureApproveAndSendModal from "../../components/ThinksToDo/JobClosureModule/JobClosureApproveAndSendModal";
import { resetMessage } from "../../redux/jobs";
import "./thinksToDo.scss";
import ShowInvoiceCountAccountInChargeModal from "../../components/ThinksToDo/ShowInvoiceCountAccountInChargeModal";
import WeeklyApprovedUsersInvoiceEntriesCountCard from "../../components/ThinksToDo/JobClosureModule/WeeklyApprovedUsersInvoiceEntriesCountCard";
import RegularizeApproveAndReject from "../../components/ThinksToDo/RegularizeApproveAndReject";
import RegularizeApproveAndRejectModal from "../../components/ThinksToDo/RegularizeApproveAndReject/RegularizeApproveAndRejectModal";
import { useLocation } from "react-router-dom";

type AppProps = {
  history: any;
  dispatchGetScheduledUpcomingInterviewsList: (
    data: GetScheduledUpcomingInterviewsListPayloadType
  ) => void;
  dispatchSingleScheduledUpcomingInterviewsDetails: (
    data: SingleScheduledUpcomingInterviewsDeatilsPayloadType
  ) => void;
  token: string | null;
  jobClosureListForRM: any[] | [];
  totalCountRM: number;
  jobClosureListData: any;
  feedbackAddedMessage: string | null;
  dispatchGetJobClosureListAction: (data: GetJobClosureListPayloadType) => void;
  scheduledUpcomingInterviewsList: ScheduledUpcomingInterviewsListType[] | [];
  singleScheduledUpcomingInterviewsDetails: SingleScheduledUpcomingInterviewsDetailsType;
  dispatchUpdateRecruitmentTrackerListAction: (
    data: AddScheduledUpcomingInterviewsDetailsType
  ) => void;
  dispatchAddCheckInScheduleFeedbackApiAction: (
    data: AddCheckInScheduleFeedbackPayloadType
  ) => void;
  dispatchResetSession: () => void;
  statusCode: number | null;
  hrmsStatusCode: number | null;
  singlePeFetching: boolean;
  success: number | null;
  hrmsSuccess: number | null;
  error: string | null;
  hrmserror: string | null;
  message: string | null;
  hrmsMessage: string | null;
  isAccountingInCharge: number;
  jobsMessage: string | null;
  peFeedbackAddedMessage: string | null;
  unApprovedInvoiceCountData: UnApprovedInvoiceCountDataListType[] | [];
  unApprovedInvoiceTotalCount: number;
  dispatchGetCheckInScheduleList: (
    data: GetCheckInScheduleListPayloadType
  ) => void;
  dispatchGetCheckInScheduleManagerViewListAction: (
    data: GetCheckInScheduleListPayloadType
  ) => void;
  dispatchGetSingleCheckInScheduleDetailsAction: (
    data: GetSingleCheckInScheduleDetailsPayloadType
  ) => void;
  dispatchResetSingleCheckInScheduleDetails: () => void;
  dispatchResetCheckInScheduleList: () => void;
  dispatchResetCheckInScheduleManagerViewList: () => void;
  dispatchResetThinksToDoError: () => void;
  dispatchResetThinksToDoMessage: () => void;
  dispatchResetThinksToDoStatusCode: () => void;
  dispatchResetThinksToDoSuccess: () => void;
  dispatchResetThinksToDoUpdateFetching: () => void;
  checkInScheduleList: GetCheckInDetailDataType[] | [];
  checkInScheduleManagerViewList: GetCheckInDetailDataType[] | [];
  loginData: LoginResponseType;
  dispatchResetScheduledUpcomingInterviewsList: () => void;
  thinksToDoFetching: boolean;
  updateFetching: boolean;
  hrmsFetching: boolean;
  dispatchApprovalListAction: (data: ApprovalListPayloadType) => void;
  approvalList: ApprovalListType[] | [];
  dispatchResetApprovalList: () => void;
  dispatchResetHrmsSuccess: () => void;
  dispatchResetHrmsMessage: () => void;
  dispatchResetHrmsError: () => void;
  dispatchApprovalStatusAction: (data: SendApprovalStatusPayloadType) => void;
  singleCheckInScheduleDetails: any;
  dispatchResetMySpaceMessage: () => void;
  dispatchResetMySpaceError: () => void;
  dispatchResetMySpaceSuccess: () => void;
  dispatchGetPerformanceEvaluationListAction: (data: any) => void;
  performanceEvaluationList: any[] | [];
  performanceEvaluationTotalCount: number;
  performanceEvaluationFetching: boolean;
  dispatchResetPerformanceEvaluationList: () => void;
  dispatchGetSinglePerformanceEvaluationDetailsAction: (data: any) => void;
  dispatchResetSinglePeDetailsList: () => void;
  singlePeDetailsList: any;
  dispatchAddPerformanceEvaluationFeedbackAction: (data: any) => void;
  dispatchGetJobClosureRMListAction: (
    data: GetJobClosureListPayloadType
  ) => void;
  dispatchResetJobClosureListForRM: () => void;
  dispatchResetTotalCountRM: () => void;
  dispatchResetJobMessage: () => void;
  dispatchGetUnApprovedInvoiceCountListAction: (
    data: GetUnApprovedInvoiceCountPayloadType
  ) => void;
  dispatchResetUnApprovedInvoiceCountData: () => void;
  dispatchResetUnApprovedInvoiceTotalCount: () => void;
  dispatchGetRegularizeApprovalPendingListAction: (
    data: GetRegularizeApprovalPendingListPayloadType
  ) => void;
  dispatchApproveOrRejectRegularizeAction: (
    data: ApproveAndRejectRegularizePayloadType
  ) => void;
  dispatchResetRegularizeApprovalPendingList: () => void;
  regularizeApprovalPendingList: any;
};
const ThinksToDo = ({
  history,
  dispatchGetScheduledUpcomingInterviewsList,
  token,
  jobClosureListData,
  scheduledUpcomingInterviewsList,
  dispatchSingleScheduledUpcomingInterviewsDetails,
  singleScheduledUpcomingInterviewsDetails,
  dispatchUpdateRecruitmentTrackerListAction,
  statusCode,
  success,
  error,
  message,
  jobsMessage,
  singlePeFetching,
  peFeedbackAddedMessage,
  jobClosureListForRM,
  totalCountRM,
  isAccountingInCharge,
  dispatchResetSession,
  dispatchResetThinksToDoError,
  dispatchResetThinksToDoMessage,
  dispatchResetThinksToDoStatusCode,
  dispatchResetThinksToDoSuccess,
  dispatchResetThinksToDoUpdateFetching,
  dispatchGetCheckInScheduleList,
  dispatchGetCheckInScheduleManagerViewListAction,
  dispatchResetCheckInScheduleList,
  dispatchResetCheckInScheduleManagerViewList,
  loginData,
  dispatchResetScheduledUpcomingInterviewsList,
  thinksToDoFetching,
  updateFetching,
  dispatchApprovalListAction,
  approvalList,
  dispatchResetHrmsSuccess,
  dispatchResetHrmsMessage,
  dispatchResetHrmsError,
  dispatchResetApprovalList,
  dispatchApprovalStatusAction,
  checkInScheduleList,
  checkInScheduleManagerViewList,
  singleCheckInScheduleDetails,
  dispatchAddCheckInScheduleFeedbackApiAction,
  dispatchGetSingleCheckInScheduleDetailsAction,
  dispatchResetSingleCheckInScheduleDetails,
  dispatchResetPerformanceEvaluationList,
  feedbackAddedMessage,
  dispatchResetMySpaceMessage,
  hrmsSuccess,
  hrmserror,
  hrmsMessage,
  hrmsStatusCode,
  dispatchResetMySpaceError,
  dispatchResetMySpaceSuccess,
  hrmsFetching,
  dispatchGetPerformanceEvaluationListAction,
  performanceEvaluationList,
  performanceEvaluationTotalCount,
  performanceEvaluationFetching,
  dispatchGetSinglePerformanceEvaluationDetailsAction,
  dispatchResetSinglePeDetailsList,
  singlePeDetailsList,
  dispatchAddPerformanceEvaluationFeedbackAction,
  dispatchGetJobClosureListAction,
  dispatchGetJobClosureRMListAction,
  dispatchResetJobClosureListForRM,
  dispatchResetTotalCountRM,
  dispatchResetJobMessage,
  dispatchGetUnApprovedInvoiceCountListAction,
  dispatchResetUnApprovedInvoiceCountData,
  dispatchResetUnApprovedInvoiceTotalCount,
  unApprovedInvoiceCountData,
  unApprovedInvoiceTotalCount,
  dispatchGetRegularizeApprovalPendingListAction,
  dispatchResetRegularizeApprovalPendingList,
  regularizeApprovalPendingList,
  dispatchApproveOrRejectRegularizeAction,
}: AppProps) => {
  const [feedbackModal, setFeedbackModal] = useState(false);
  const [checkInFeedbackModal, setCheckInFeedbackModal] = useState(false);
  const [singleId, setSingleId] = useState("");
  const [approvalId, setApprovalId] = useState("");
  const [singleScheduledDetails, setSingleScheduledDetails] = useState<any>({});
  const [isApproved, setIsApproved] = useState(true);
  const [isInterviewApproval, setIsInterviewApproval] = useState(false);
  const [isInterViewApprovalComment, setIsInterViewApprovalComment] =
    useState("");
  const [checkInId, setCheckInId] = useState<string>("");
  const [feedback, setFeedback] = useState<string>("");
  const [showOpenManagerFeedbackModal, setShowOpenManagerFeedbackModal] =
    useState(false);
  const [performanceEvaluationId, setPerformanceEvaluationId] = useState("");
  const [feedbackComment, setFeedbackComment] = useState("");
  const [performanceRating, setPerformanceRating] = useState({
    value: "",
    label: "Select..",
  });
  const [imageDetails, setImageDetails] = useState<ImageDataType>({
    imageUrl: "",
    downloadImage: "",
    fileType: "",
    finalFileName: "",
    updateBy: "",
    updatedAt: "",
  });
  const [
    showApproveAndSendForClosureModal,
    setShowApproveAndSendForClosureModal,
  ] = useState<boolean>(false);
  const [
    showApproveAndRejectRegularizeModal,
    setShowApproveAndRejectRegularizeModal,
  ] = useState<boolean>(false);
  const [
    showInvoiceCountAccountInChargeModal,
    setShowInvoiceCountAccountInChargeModal,
  ] = useState<boolean>(false);
  const [showCloseJobRMModal, setShowCloseJobRMModal] =
    useState<boolean>(false);
  const [jobTypeId, setJobTypeId] = useState("");
  const [jobId, setJobId] = useState("");
  const [regularizeData, setRegularizeData] = useState(null);

  let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
  let blobToken = process.env.REACT_APP_BLOB_TOEKN;

  let blobSasUrl = `${blobBaseUrl}?${blobToken}`;
  const blobServiceClient = new BlobServiceClient(blobSasUrl);
  const containerName: any = process.env.REACT_APP_USER_CONTAINER_NAME;
  const containerClient = blobServiceClient.getContainerClient(containerName);
  const [uploadFetching, setUploadFetching] = useState(false);
  const [files, setFiles] = useState<any>([]);
  const search = useLocation().search;
  const regularizeNotificationId = new URLSearchParams(search).get(
    "notification_id"
  );

  // User Management //
  const [isMyCheckInsViewPresent, setIsMyCheckInsViewPresent] =
    useMenuCheck("");
  const [isManagerViewCheckInsPresent, setIsManagerViewCheckInsPresent] =
    useMenuCheck("");
  const [
    isManagerPerformanceEvaluationPresent,
    setIsManagerPerformanceEvaluationPresent,
  ] = useMenuCheck("");

  const [
    isScheduledUpcomingInterviewsPresent,
    setIsScheduledUpcomingInterviewsPresent,
  ] = useMenuCheck("Upcoming Interviews");
  const [
    isPendingInterviewApprovalsPresent,
    setIsPendingInterviewApprovalsPresent,
  ] = useMenuCheck("Interview Approvals");

  const [isCheckinListPresent, setIsCheckInListPresent] =
    useMenuCheck("Check-Ins");
  const [
    isPerformanceEvaluationListPresent,
    setIsPerformanceEvaluationListPresent,
  ] = useMenuCheck("PE");

  const [isjobClosureForRM, setIsJobClosureForRM] = useMenuCheck("rm");
  const [isJobClosureForManager, setIsJobClosureForManager] =
    useMenuCheck("manager");

  const [isRegularisePresent, setIsRegularisePresent] =
    useMenuCheck("regularise");

  const [
    isUsersWeeklyApprovedInvoiceTotalCount,
    setIsUsersWeeklyApprovedInvoiceTotalCount,
  ] = useMenuCheck("weeklyApproved");
  // User Management //

  useEffect(() => {
    window.scrollTo(0, 0);
    setIsMyCheckInsViewPresent("My Check-Ins View", "menu");
    setIsManagerViewCheckInsPresent("Manager Check-Ins View", "menu");
    setIsScheduledUpcomingInterviewsPresent(
      "Scheduled Upcoming Interviews",
      "menu"
    );
    setIsCheckInListPresent("Check-In Schedule List", "menu");
    setIsPendingInterviewApprovalsPresent(
      "Pending Things to Do Interview Approvals",
      "menu"
    );
    setIsPerformanceEvaluationListPresent(
      "Performance Evaluation List",
      "menu"
    );
    setIsManagerPerformanceEvaluationPresent(
      "Manager's View Performance Evaluation Form",
      "menu"
    );
    setIsJobClosureForRM("Job Closure List For RM", "menu");
    setIsJobClosureForManager("Job Closure List For Manager", "menu");
    setIsUsersWeeklyApprovedInvoiceTotalCount(
      "Weekly Approved Users Invoice Entries Count",
      "menu"
    );
    setIsRegularisePresent("Approve and Reject Regularise", "menu");
    //
    dispatchResetThinksToDoError();
    dispatchResetThinksToDoMessage();
    dispatchResetThinksToDoStatusCode();
    dispatchResetThinksToDoSuccess();
    dispatchResetScheduledUpcomingInterviewsList();
    dispatchResetHrmsSuccess();
    dispatchResetHrmsMessage();
    dispatchResetHrmsError();
    dispatchResetApprovalList();
    dispatchResetThinksToDoUpdateFetching();
    dispatchResetCheckInScheduleList();
    dispatchResetSingleCheckInScheduleDetails();
    dispatchResetMySpaceMessage();
    dispatchResetCheckInScheduleManagerViewList();
    dispatchResetRegularizeApprovalPendingList();
    dispatchResetJobMessage();
  }, []);

  useEffect(() => {
    if (token && isRegularisePresent) {
      const finalData = {
        token,
        role: "manager",
        notificationId: regularizeNotificationId,
      };
      dispatchGetRegularizeApprovalPendingListAction(finalData);
    }
  }, [isRegularisePresent]);

  useEffect(() => {
    if (singleCheckInScheduleDetails?.feedback) {
      setFeedback(singleCheckInScheduleDetails?.feedback);
    } else {
      setFeedback("");
    }
  }, [singleCheckInScheduleDetails]);

  useEffect(() => {
    dispatchResetCheckInScheduleList();
    dispatchResetSingleCheckInScheduleDetails();
    dispatchResetMySpaceMessage();
    dispatchResetCheckInScheduleManagerViewList();
    if (token && loginData?.user_id) {
      const finalData = {
        token,
        userId: loginData?.user_id,
        role: "user",
        presentTime: 1,
      };
      isCheckinListPresent &&
        isMyCheckInsViewPresent &&
        dispatchGetCheckInScheduleList(finalData);
      const finalParams = {
        token,
        role: "manager",
        presentTime: 1,
      };
      isCheckinListPresent &&
        isManagerViewCheckInsPresent &&
        dispatchGetCheckInScheduleManagerViewListAction(finalParams);
    }
  }, [isCheckinListPresent]);

  //
  useEffect(() => {
    dispatchResetPerformanceEvaluationList();
    dispatchResetSinglePeDetailsList();
    dispatchResetMySpaceMessage();
    if (token) {
      const finalData = {
        token,
        offset: 0,
        limit: 2,
        role: "manager",
      };
      isPerformanceEvaluationListPresent &&
        dispatchGetPerformanceEvaluationListAction(finalData);
    }
  }, [isPerformanceEvaluationListPresent]);
  //

  //
  useEffect(() => {
    // dispatchResetPerformanceEvaluationList();
    // dispatchResetSinglePeDetailsList();
    dispatchResetMySpaceMessage();
    if (token) {
      const finalData = {
        token,
        offset: 0,
        limit: 2,
        role: "manager",
        internalStatus: "1",
        type: "things_to_do_manager",
      };
      isJobClosureForManager && dispatchGetJobClosureListAction(finalData);
    }
  }, [isJobClosureForManager]);
  useEffect(() => {
    dispatchResetJobClosureListForRM();
    // dispatchResetSinglePeDetailsList();
    dispatchResetMySpaceMessage();
    if (token) {
      const finalData = {
        token,
        offset: 0,
        limit: 2,
        role: "all",
        internalStatus: "3",
        jobstatus: "Open",
        type: "things_to_do_rm",
      };
      isjobClosureForRM && dispatchGetJobClosureRMListAction(finalData);
    }
  }, [isjobClosureForRM]);
  useEffect(() => {
    dispatchResetUnApprovedInvoiceCountData();
    dispatchResetMySpaceMessage();
    if (token) {
      const finalData = {
        token,
      };
      dispatchGetUnApprovedInvoiceCountListAction(finalData);
    }
  }, []);
  useEffect(() => {
    if (token) {
      const finalData = {
        token,
        today: reverseDate(currentDate()),
      };
      if (isScheduledUpcomingInterviewsPresent) {
        dispatchGetScheduledUpcomingInterviewsList(finalData);
      }

      const finaDataApprovalList = {
        approver_id: loginData?.user_id,
        token,
        today: reverseDate(currentDate()),
        type: "things_to_do",
        // sort_by: "approved_at",
        // sorting_order: -1,
      };
      if (isPendingInterviewApprovalsPresent) {
        dispatchApprovalListAction(finaDataApprovalList);
      }
    }
  }, [
    isPendingInterviewApprovalsPresent,
    isScheduledUpcomingInterviewsPresent,
  ]);

  useEffect(() => {
    if (
      singleScheduledUpcomingInterviewsDetails &&
      Object.keys(singleScheduledUpcomingInterviewsDetails)
    ) {
      setSingleScheduledDetails({
        ...singleScheduledUpcomingInterviewsDetails,
      });
    }
  }, [singleScheduledUpcomingInterviewsDetails]);

  useEffect(() => {
    if (
      feedbackAddedMessage?.includes(
        "Check-in feedback details has been added successfully!"
      )
    ) {
      toast.success("Check-in feedback details has been added successfully!", {
        duration: 3000,
      });
      dispatchResetMySpaceError();
      dispatchResetMySpaceMessage();
      dispatchResetMySpaceSuccess();
      loginData?.user_id == singleCheckInScheduleDetails?.updated_by?.user_id &&
        dispatchResetCheckInScheduleList();
      loginData?.user_id == singleCheckInScheduleDetails?.manager?.user_id &&
        dispatchResetCheckInScheduleManagerViewList();
      if (token && loginData?.user_id) {
        const finalData = {
          token,
          userId: loginData?.user_id,
          role: "user",
          presentTime: 1,
        };
        isCheckinListPresent &&
          isMyCheckInsViewPresent &&
          loginData?.user_id ==
            singleCheckInScheduleDetails?.updated_by?.user_id &&
          dispatchGetCheckInScheduleList(finalData);
        const finalParams = {
          token,
          role: "manager",
          presentTime: 1,
        };
        isCheckinListPresent &&
          isManagerViewCheckInsPresent &&
          loginData?.user_id ==
            singleCheckInScheduleDetails?.manager?.user_id &&
          dispatchGetCheckInScheduleManagerViewListAction(finalParams);
      }
    }
  }, [feedbackAddedMessage]);

  //
  useEffect(() => {
    if (
      peFeedbackAddedMessage?.includes(
        "Performance Evaluation feedback and rating details has been added successfully!"
      )
    ) {
      toast.success(
        "Performance Evaluation feedback and rating details has been added successfully!",
        {
          duration: 3000,
        }
      );
      dispatchResetMySpaceError();
      dispatchResetMySpaceMessage();
      dispatchResetMySpaceSuccess();

      dispatchResetPerformanceEvaluationList();
      if (token) {
        const finalData = {
          token,
          offset: 0,
          limit: 2,
          role: "manager",
        };
        dispatchGetPerformanceEvaluationListAction(finalData);
      }
    }
  }, [feedbackAddedMessage]);

  const handleFeedBackAdded = (data: string) => {
    if (isInterviewApproval) {
      setIsInterViewApprovalComment(data);
    }
    let updatedInterviewRoundDetails = [
      ...singleScheduledUpcomingInterviewsDetails?.interview_details
        ?.interview_round_details,
    ];

    let lastInterview =
      updatedInterviewRoundDetails[updatedInterviewRoundDetails.length - 1];

    let updatedLastInterview = {
      ...lastInterview,
      is_feedback_submited: true,
      interview_feedback: data,
    };

    updatedInterviewRoundDetails[updatedInterviewRoundDetails.length - 1] =
      updatedLastInterview;

    setSingleScheduledDetails({
      ...singleScheduledUpcomingInterviewsDetails,
      interview_details: {
        ...singleScheduledUpcomingInterviewsDetails?.interview_details,
        interview_round_details: updatedInterviewRoundDetails,
      },
    });
  };

  const handleFeedBackModal = (data?: string) => {
    dispatchResetThinksToDoError();
    dispatchResetThinksToDoMessage();
    dispatchResetThinksToDoStatusCode();
    dispatchResetThinksToDoSuccess();
    setFeedbackModal(!feedbackModal);
    if (data) {
      setSingleId(data);
    } else {
      setSingleId("");
    }
  };

  const handleRegularizeFeedBackModal = (data: any) => {
    setRegularizeData(data);
    setShowApproveAndRejectRegularizeModal(
      !showApproveAndRejectRegularizeModal
    );
  };

  const handleCheckInFeedBackModal = (data?: string) => {
    setCheckInFeedbackModal(!checkInFeedbackModal);
    dispatchResetSingleCheckInScheduleDetails();
    if (data) {
      setCheckInId(data);
    } else {
      setCheckInId("");
    }
    if (token && data) {
      const finalData = {
        token,
        checkInId: data,
      };
      dispatchGetSingleCheckInScheduleDetailsAction(finalData);
    }
  };

  const handleToggle = () => {
    setCheckInFeedbackModal(!checkInFeedbackModal);
  };

  const handleCheckInFeedBackSubmit = () => {
    if (token) {
      const finalData = {
        token,
        checkInId,
        feedback,
      };
      dispatchAddCheckInScheduleFeedbackApiAction(finalData);
    }
  };
  const handleRegularizeFeedBackSubmit = (
    data: ApproveAndRejectRegularizePayloadType
  ) => {
    if (token) {
      const finalData = {
        token,
        ...data,
      };
      dispatchApproveOrRejectRegularizeAction(finalData);
    }
  };

  useEffect(() => {
    if (feedbackModal && token) {
      let finalData = {
        token,
        id: singleId,
        type: "things_to_do",
      };
      dispatchSingleScheduledUpcomingInterviewsDetails(finalData);
    }
    if (!feedbackModal) {
      setIsInterviewApproval(false);
    }
  }, [feedbackModal]);

  const toggleSubmitManagerFeedback = (data?: any) => {
    dispatchResetMySpaceError();
    if (data) {
      setPerformanceEvaluationId(data);
      let finalData = {
        token,
        performanceEvaluationId: data,
      };
      dispatchGetSinglePerformanceEvaluationDetailsAction(finalData);
    }
    setShowOpenManagerFeedbackModal((prev: boolean) => !prev);
    setPerformanceRating({
      value: "",
      label: "Select..",
    });
    setFeedbackComment("");
  };

  const handleToggleManagerApproveAndSendJob = () => {
    setShowApproveAndSendForClosureModal(!showApproveAndSendForClosureModal);
  };

  const handleToggleApproveAndRejectRegularize = () => {
    setShowApproveAndRejectRegularizeModal(
      !showApproveAndRejectRegularizeModal
    );
  };

  const handleToggleRMClosureJob = () => {
    setShowCloseJobRMModal(!showCloseJobRMModal);
  };
  const toggleApproveAndSendJob = (data: any) => {
    setShowApproveAndSendForClosureModal(!showApproveAndSendForClosureModal);
    setJobTypeId(data?.job_id);
    setJobId(data?._id);
  };
  const toggleCloseJob = (data: any) => {};

  const uploadFiles = async (uploadedFile: any) => {
    const file = uploadedFile?.target?.files[0];
    try {
      setUploadFetching(true);
      let resp;
      const blockBlobClient = containerClient.getBlockBlobClient(
        new Date().valueOf() +
          "." +
          file.name.split(".")[file.name.split(".").length - 1]
      );
      resp = await blockBlobClient.uploadBrowserData(file);
      if (
        resp &&
        resp["_response"] &&
        resp["_response"].status &&
        (resp["_response"].status === 201 || resp["_response"].status ===  200)
      ) {
        updateDocumentAPI(
          file.name,
          // file.id,
          blockBlobClient["_name"],
          blockBlobClient["_containerName"],
          file.type
        );
        setUploadFetching(false);
      } else {
        setUploadFetching(false);
        alert("something wrong");
      }
    } catch (error) {}
  };
  const getImageDetails = (data: any) => {
    setImageDetails({
      ...data,
      imageUrl: blobBaseUrl + data.file_url + "?" + blobToken,
      downloadImage: data.file_url,
      fileType: data.file_type,
      finalFileName: data.file_name,
    });
  };
  const updateDocumentAPI = (
    file_name: string,
    url_name: string,
    url_container: string,
    file_type: string
  ) => {
    let data: any = {
      file_name,
      file_url: url_container + "/" + url_name,
      file_type,
    };
    getImageDetails(data);
    if (files.length > 0) {
      setFiles((prevFiles: any) => [...prevFiles, data]);
    } else {
      setFiles([data]);
    }
  };
  const handleDeleteUploadedFile = (indexToDelete: number) => {
    const updatedFiles = files.filter(
      (_: any, index: number) => index !== indexToDelete
    );
    setFiles(updatedFiles);
  };
  const handleManagerFeedback = () => {
    if (token) {
      const finalData = {
        token,
        performanceEvaluationId,
        feedbackComment,
        performanceRating: performanceRating?.value,
        managerFileAttach: files,
      };
      dispatchAddPerformanceEvaluationFeedbackAction(finalData);
    }
  };

  const handlePerformanceRatingChange = (data: any) => {
    setPerformanceRating({
      value: data?.value,
      label: data?.label,
    });
  };
  const handleCommentChange = (e: any) => {
    setFeedbackComment(e);
  };

  const handleSubmitFeedback = () => {
    if (isInterviewApproval && token) {
      const finalData = {
        token,
        _id: approvalId,
        comment: isInterViewApprovalComment,
        status: isApproved ? 3 : 2,
      };
      dispatchApprovalStatusAction(finalData);
      handleFeedBackModal();
    } else if (token) {
      let interviewDetailsRounds =
        singleScheduledDetails?.interview_details?.interview_round_details?.map(
          (el: any) => {
            return {
              ...el,
              interviewer: el.interviewer?.user_id,
            };
          }
        );
      const finalData = {
        token,
        finalData: {
          ...singleScheduledUpcomingInterviewsDetails,
          id: singleScheduledUpcomingInterviewsDetails?._id,
          applicant_details: {
            ...singleScheduledUpcomingInterviewsDetails?.applicant_details,
            qualification:
              singleScheduledUpcomingInterviewsDetails?.applicant_details?.qualification?.map(
                (data: any) => data?._id
              ),
            skill:
              singleScheduledUpcomingInterviewsDetails?.applicant_details?.skill?.map(
                (data: any) => data?._id
              ),
          },
          position_details: {
            ...singleScheduledUpcomingInterviewsDetails?.position_details,
            department:
              singleScheduledUpcomingInterviewsDetails?.position_details
                ?.department?.id,
            job_position:
              singleScheduledUpcomingInterviewsDetails?.position_details?.job_position?.id.toString(),
            offered_job_position:
              singleScheduledUpcomingInterviewsDetails?.position_details
                ?.offered_job_position?.id,
            job_location:
              singleScheduledUpcomingInterviewsDetails?.position_details
                ?.job_location?.id,
            recruiter:
              singleScheduledUpcomingInterviewsDetails?.position_details
                ?.recruiter?.user_id,
            proposed_joining_date: singleScheduledUpcomingInterviewsDetails?.position_details?.proposed_joining_date ? formatDate(singleScheduledUpcomingInterviewsDetails?.position_details?.proposed_joining_date) : null
          },
          interview_details: {
            ...singleScheduledUpcomingInterviewsDetails?.interview_details,
            application_date: formatDate(
              singleScheduledUpcomingInterviewsDetails?.interview_details
                ?.application_date
            ),
            screening_details: {
              ...singleScheduledUpcomingInterviewsDetails?.interview_details
                ?.screening_details,
              phone_screener:
                singleScheduledUpcomingInterviewsDetails?.interview_details
                  ?.screening_details?.phone_screener?.user_id,
            },
            interview_round_details: [...interviewDetailsRounds],
          },
          other_details: {
            ...singleScheduledUpcomingInterviewsDetails?.other_details,
            referred_by:
              singleScheduledUpcomingInterviewsDetails?.other_details
                ?.referred_by?.user_id,
          },
        },
      };
      dispatchUpdateRecruitmentTrackerListAction(finalData);
      handleFeedBackModal();
    }
  };
  
  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetThinksToDoError();
              dispatchResetMySpaceError();
              dispatchResetMySpaceMessage();
              dispatchResetMySpaceSuccess();
            }}
          />
        );
      }
    } else if (hrmsSuccess === 0) {
      if (
        hrmsStatusCode === 407 &&
        hrmserror &&
        hrmserror === "You're Not Authorized. Please contact admin!"
      ) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!hrmserror}
            title="Error"
            message="You're Not Authorized. Please contact admin!"
            buttonText="OK"
            statusCode={hrmsStatusCode}
            onPress={() => {
              dispatchResetThinksToDoError();
              dispatchResetHrmsError();
            }}
          />
        );
      }
    } else if (
      message === "Recruitment details has been updated successfully."
    ) {
      toast.success("Feedback have been added successfuly", {
        duration: 2000,
      });

      dispatchResetThinksToDoError();
      dispatchResetThinksToDoMessage();
      dispatchResetThinksToDoStatusCode();
      dispatchResetThinksToDoSuccess();
      dispatchResetScheduledUpcomingInterviewsList();
      if (token) {
        const finalData = {
          token,
          today: reverseDate(currentDate()),
        };

        dispatchGetScheduledUpcomingInterviewsList(finalData);
      }
    } else if (message === "Recruitment approval request has been rejected.") {
      toast.success("Recruitment approval request has been rejected", {
        duration: 2000,
      });

      dispatchResetThinksToDoError();
      dispatchResetThinksToDoMessage();
      dispatchResetThinksToDoStatusCode();
      dispatchResetThinksToDoSuccess();
      if (token) {
        const finaDataApprovalList = {
          approver_id: loginData?.user_id,
          token,
          today: reverseDate(currentDate()),
          type: "things_to_do",
        };
        dispatchApprovalListAction(finaDataApprovalList);
      }
    } else if (message === "Recruitment approval request has been approved.") {
      toast.success("Recruitment approval request has been approved.", {
        duration: 2000,
      });

      dispatchResetThinksToDoError();
      dispatchResetThinksToDoMessage();
      dispatchResetThinksToDoStatusCode();
      dispatchResetThinksToDoSuccess();
      if (token) {
        const finaDataApprovalList = {
          approver_id: loginData?.user_id,
          token,
          today: reverseDate(currentDate()),
          type: "things_to_do",
        };
        dispatchApprovalListAction(finaDataApprovalList);
      }
    } else if (
      message === "Job closure request has been approved." ||
      message === "Job closure request has been rejected."
    ) {
      toast.success(
        message === "Job closure request has been approved."
          ? "Job closure request has been approved"
          : "Job closure request has been rejected",
        {
          duration: 2000,
        }
      );

      dispatchResetThinksToDoError();
      dispatchResetThinksToDoMessage();
      dispatchResetThinksToDoStatusCode();
      dispatchResetThinksToDoSuccess();
      if (token) {
        const finalData = {
          token,
          offset: 0,
          limit: 2,
          role: "manager",
          internalStatus: "1",
          type: "things_to_do_manager",
        };
        isJobClosureForManager && dispatchGetJobClosureListAction(finalData);
      }
    } else if (jobsMessage === "Job has been updated successfully!") {
      toast.success("Job has been closed successfully.", {
        duration: 2000,
      });
      dispatchResetJobMessage();
      dispatchResetThinksToDoError();
      dispatchResetThinksToDoMessage();
      dispatchResetThinksToDoStatusCode();
      dispatchResetThinksToDoSuccess();
      if (token) {
        const finalData = {
          token,
          offset: 0,
          limit: 2,
          role: "all",
          internalStatus: "3",
          jobstatus: "Open",
          type: "things_to_do_rm",
        };
        dispatchGetJobClosureRMListAction(finalData);
      }
    } else if (
      message === "Attendance regularization approved successfully." ||
      message === "Attendance regularization rejected successfully."
    ) {
      toast.success(
        message === "Attendance regularization approved successfully."
          ? "Attendance regularization approved successfully."
          : "Attendance regularization rejected successfully.",
        {
          duration: 2000,
        }
      );
      dispatchResetThinksToDoError();
      dispatchResetThinksToDoMessage();
      dispatchResetThinksToDoStatusCode();
      dispatchResetThinksToDoSuccess();
      dispatchResetRegularizeApprovalPendingList();
      if (token && isRegularisePresent) {
        const finalData = {
          token,
          role: "manager",
          notificationId: regularizeNotificationId,
        };
        dispatchGetRegularizeApprovalPendingListAction(finalData);
      }
    }

    return false;
  };

  return (
    <>
      <div className="col-md-6">
        <CommonHeader title={`Things To Do`} />
      </div>
      <div>
        <WeeklyApprovedUsersInvoiceEntriesCountCard />
      </div>
      <div
        className="mainThingToDoDiv"
        style={{
          display: "grid",
          gridTemplateColumns: "49% 49% ",
          gap: "1%",
        }}
      >
        {isScheduledUpcomingInterviewsPresent && (
          <div>
            <ScheduledUpcomingInterviews
              scheduledUpcomingInterviewsList={scheduledUpcomingInterviewsList}
              handleFeedBackModal={handleFeedBackModal}
              history={history}
              loginData={loginData}
              thinksToDoFetching={thinksToDoFetching}
            />
          </div>
        )}
        {isPendingInterviewApprovalsPresent && (
          <div>
            <PendingInterviewApprovals
              approvalList={approvalList}
              handleFeedBackModal={handleFeedBackModal}
              history={history}
              loginData={loginData}
              thinksToDoFetching={hrmsFetching}
              setIsApproved={setIsApproved}
              isApproved={isApproved}
              setIsInterviewApproval={setIsInterviewApproval}
              setApprovalId={setApprovalId}
            />
          </div>
        )}

        {isMyCheckInsViewPresent && (
          <div className="">
            <UpcomingCheckInSchedule
              checkInScheduleList={checkInScheduleList}
              handleFeedBackModal={handleCheckInFeedBackModal}
              history={history}
              loginData={loginData}
              thinksToDoFetching={thinksToDoFetching}
              isCheckinListPresent={isCheckinListPresent}
            />
          </div>
        )}
        {isManagerViewCheckInsPresent && (
          <div>
            <UpcomingUsersCheckInSchedule
              checkInScheduleList={checkInScheduleManagerViewList}
              handleFeedBackModal={handleCheckInFeedBackModal}
              history={history}
              loginData={loginData}
              thinksToDoFetching={thinksToDoFetching}
              isCheckinListPresent={isCheckinListPresent}
            />
          </div>
        )}
        {isManagerPerformanceEvaluationPresent && (
          <div>
            <ManagerPEform
              performanceEvaluationList={performanceEvaluationList}
              handleFeedBackModal={toggleSubmitManagerFeedback}
              history={history}
              loginData={loginData}
              thinksToDoFetching={performanceEvaluationFetching}
              isPerformanceEvaluationListPresent={
                isPerformanceEvaluationListPresent
              }
            />
          </div>
        )}
        {isJobClosureForManager && (
          <div>
            <ManagerJobClosureRequests
              jobClosureListData={jobClosureListData}
              handleApproveAndSendModal={toggleApproveAndSendJob}
              history={history}
              thinksToDoFetching={thinksToDoFetching}
            />
          </div>
        )}

        {isjobClosureForRM && (
          <div>
            <ManagerJobClosureRequests
              jobClosureListData={jobClosureListForRM}
              handleApproveAndSendModal={toggleCloseJob}
              history={history}
              thinksToDoFetching={thinksToDoFetching}
              type={"RM"}
              jobId={jobId}
            />
          </div>
        )}
        {isAccountingInCharge === 1 ? (
          <div>
            <ShowInvoiceCountAccountInChargeModal
              unApprovedInvoiceCountData={unApprovedInvoiceCountData}
              history={history}
              thinksToDoFetching={thinksToDoFetching}
            />
          </div>
        ) : (
          ""
        )}
        {isRegularisePresent ? (
          <div>
            <RegularizeApproveAndReject
              data={regularizeApprovalPendingList}
              handleFeedBackModal={handleRegularizeFeedBackModal}
              fetching={thinksToDoFetching}
            />
          </div>
        ) : null}
      </div>
      {feedbackModal && (
        <FeedBackModal
          toggle={handleFeedBackModal}
          isOpen={feedbackModal}
          data={singleScheduledUpcomingInterviewsDetails}
          hanldeFeedback={handleFeedBackAdded}
          handleSubmitFeedback={handleSubmitFeedback}
          loginData={loginData}
          fetching={thinksToDoFetching}
          isInterviewApproval={isInterviewApproval}
          isApproved={isApproved}
          setIsApproved={setIsApproved}
          approvalId={approvalId}
          type={"finaccrm"}
        />
      )}
      {checkInFeedbackModal && singleCheckInScheduleDetails && (
        <CheckInFeedBackModal
          toggle={handleToggle}
          isOpen={checkInFeedbackModal}
          data={singleCheckInScheduleDetails}
          handleSubmitFeedback={handleCheckInFeedBackSubmit}
          loginData={loginData}
          fetching={thinksToDoFetching}
          feedback={feedback}
          setFeedback={setFeedback}
        />
      )}
      {showOpenManagerFeedbackModal && (
        <ManagerViewPEFormModal
          success={success}
          isOpen={showOpenManagerFeedbackModal}
          data={singlePeDetailsList}
          toggleSubmitManagerFeedback={toggleSubmitManagerFeedback}
          fetching={singlePeFetching}
          feedbackComment={feedbackComment}
          handleCommentChange={handleCommentChange}
          performanceRating={performanceRating}
          handlePerformanceRatingChange={handlePerformanceRatingChange}
          handleAddManagerFeedback={handleManagerFeedback}
          uploadFiles={uploadFiles}
          files={files}
          uploadFetching={uploadFetching}
          handleDeleteUploadedFile={handleDeleteUploadedFile}
        />
      )}
      {showApproveAndSendForClosureModal && (
        <JobClosureApproveAndSendModal
          modal={showApproveAndSendForClosureModal}
          toggleModal={handleToggleManagerApproveAndSendJob}
          jobTypeId={jobTypeId}
          jobId={jobId}
          type={"manager"}
          hideUserWorkingTab={true}
        />
      )}
      {showApproveAndRejectRegularizeModal && (
        <RegularizeApproveAndRejectModal
          isOpen={showApproveAndRejectRegularizeModal}
          toggle={handleToggleApproveAndRejectRegularize}
          data={regularizeData}
          handleRegularizeFeedBackSubmit={handleRegularizeFeedBackSubmit}
          loginData={loginData}
        />
      )}

      {handleErrorModal()}
      <Toaster />
      {updateFetching && <Loader />}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  scheduledUpcomingInterviewsList: state.thinksToDo.scheduledUpcomingInterviews,
  singleScheduledUpcomingInterviewsDetails:
    state.thinksToDo.singleScheduledUpcomingInterviewsDetails,
  error: state.thinksToDo.error,
  statusCode: state.thinksToDo.statusCode,
  success: state.thinksToDo.success,
  message: state.thinksToDo.message,
  hrmserror: state.hrms.error,
  hrmsStatusCode: state.hrms.statusCode,
  hrmsSuccess: state.hrms.success,
  hrmsMessage: state.hrms.message,
  loginData: state.auth.loginData,
  thinksToDoFetching: state.thinksToDo.fetching,
  updateFetching: state.thinksToDo.updateFetching,
  approvalList: state.hrms.approvalList,
  checkInScheduleList: state.mySpace.checkInScheduleList,
  checkInScheduleManagerViewList: state.mySpace.checkInScheduleManagerViewList,
  singleCheckInScheduleDetails: state.mySpace.singleCheckInScheduleDetails,
  feedbackAddedMessage: state.mySpace.message,
  hrmsFetching: state.hrms.fetching,
  peFeedbackAddedMessage: state.mySpace.message,
  performanceEvaluationList: state.mySpace.performanceEvaluationList,
  performanceEvaluationTotalCount:
    state.mySpace.performanceEvaluationTotalCount,
  performanceEvaluationFetching: state.mySpace.performanceEvaluationFetching,
  singlePeDetailsList: state.mySpace.singlePeDetailsList,
  singlePeFetching: state.mySpace.singlePeFetching,
  jobClosureListData: state.thinksToDo.jobClosureListData,
  jobClosureListForRM: state.thinksToDo.jobClosureListForRM,
  totalCountRM: state.thinksToDo.totalCountRM,
  jobsMessage: state.jobs.message,
  unApprovedInvoiceCountData: state.thinksToDo.unApprovedInvoiceCountData,
  unApprovedInvoiceTotalCount: state.thinksToDo.unApprovedInvoiceTotalCount,
  isAccountingInCharge: state.thinksToDo.isAccountingInCharge,
  regularizeApprovalPendingList: state.thinksToDo.regularizeApprovalPendingList,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetJobMessage: () => dispatch(resetMessage()),
  dispatchGetScheduledUpcomingInterviewsList: (
    data: GetScheduledUpcomingInterviewsListPayloadType
  ) => dispatch(getScheduledUpcomingInterviewsList(data)),
  dispatchSingleScheduledUpcomingInterviewsDetails: (
    data: SingleScheduledUpcomingInterviewsDeatilsPayloadType
  ) => dispatch(singleScheduledUpcomingInterviewsDetailsAction(data)),
  dispatchUpdateRecruitmentTrackerListAction: (
    data: AddScheduledUpcomingInterviewsDetailsType
  ) => dispatch(updateRecruitmentTrackerAction(data)),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetThinksToDoError: () => dispatch(resetThinksToDoError()),
  dispatchResetThinksToDoMessage: () => dispatch(resetThinksToDoMessage()),
  dispatchResetThinksToDoStatusCode: () =>
    dispatch(resetThinksToDoStatusCode()),
  dispatchResetThinksToDoSuccess: () => dispatch(resetThinksToDoSuccess()),
  dispatchResetThinksToDoUpdateFetching: () =>
    dispatch(resetThinksToDoUpdateFetching()),

  dispatchResetScheduledUpcomingInterviewsList: () =>
    dispatch(resetScheduledUpcomingInterviewsList()),
  dispatchApprovalListAction: (data: ApprovalListPayloadType) =>
    dispatch(getApprovalListAction(data)),
  dispatchResetApprovalList: () => dispatch(resetApprovalList()),
  dispatchResetHrmsSuccess: () => dispatch(resetHrmsSuccess()),
  dispatchResetHrmsMessage: () => dispatch(resetHrmsMessage()),
  dispatchResetHrmsError: () => dispatch(resetHrmsError()),
  dispatchApprovalStatusAction: (data: SendApprovalStatusPayloadType) =>
    dispatch(sendApprovalStatusAction(data)),
  dispatchGetCheckInScheduleList: (data: GetCheckInScheduleListPayloadType) =>
    dispatch(getCheckInScheduleListAction(data)),
  dispatchGetCheckInScheduleManagerViewListAction: (
    data: GetCheckInScheduleListPayloadType
  ) => dispatch(getCheckInScheduleManagerViewListAction(data)),
  dispatchAddCheckInScheduleFeedbackApiAction: (
    data: AddCheckInScheduleFeedbackPayloadType
  ) => dispatch(addCheckInScheduleFeedbackApiAction(data)),
  dispatchGetSingleCheckInScheduleDetailsAction: (
    data: GetSingleCheckInScheduleDetailsPayloadType
  ) => dispatch(getSingleCheckInScheduleDetailsAction(data)),
  dispatchResetSingleCheckInScheduleDetails: () =>
    dispatch(resetSingleCheckInScheduleDetails()),
  dispatchResetCheckInScheduleList: () => dispatch(resetCheckInScheduleList()),
  dispatchResetCheckInScheduleManagerViewList: () =>
    dispatch(resetCheckInScheduleManagerViewList()),
  dispatchResetMySpaceMessage: () => dispatch(resetMySpaceMessage()),
  dispatchResetMySpaceError: () => dispatch(resetMySpaceError()),
  dispatchResetMySpaceSuccess: () => dispatch(resetMySpaceSuccess()),
  dispatchGetPerformanceEvaluationListAction: (data: any) =>
    dispatch(getPerformanceEvaluationListAction(data)),
  dispatchResetPerformanceEvaluationList: () =>
    dispatch(resetPerformanceEvaluationList()),
  dispatchGetSinglePerformanceEvaluationDetailsAction: (data: any) =>
    dispatch(getSinglePerformanceEvaluationDetailsAction(data)),
  dispatchResetSinglePeDetailsList: () => dispatch(resetSinglePeDetailsList()),
  dispatchAddPerformanceEvaluationFeedbackAction: (data: any) =>
    dispatch(addPerformanceEvaluationFeedbackAction(data)),
  dispatchGetJobClosureListAction: (data: GetJobClosureListPayloadType) =>
    dispatch(getJobClosureListAction(data)),
  dispatchGetJobClosureRMListAction: (data: GetJobClosureListPayloadType) =>
    dispatch(getJobClosureRMListAction(data)),
  dispatchResetJobClosureListForRM: () => dispatch(resetJobClosureListForRM()),
  dispatchResetTotalCountRM: () => dispatch(resetTotalCountRM()),
  dispatchGetUnApprovedInvoiceCountListAction: (
    data: GetUnApprovedInvoiceCountPayloadType
  ) => dispatch(getUnApprovedInvoiceCountListAction(data)),
  dispatchGetRegularizeApprovalPendingListAction: (
    data: GetRegularizeApprovalPendingListPayloadType
  ) => dispatch(getRegularizeApprovalPendingListAction(data)),
  dispatchResetUnApprovedInvoiceCountData: () =>
    dispatch(resetUnApprovedInvoiceCountData()),
  dispatchResetUnApprovedInvoiceTotalCount: () =>
    dispatch(resetUnApprovedInvoiceTotalCount()),
  dispatchResetRegularizeApprovalPendingList: () =>
    dispatch(resetRegularizeApprovalPendingList()),
  dispatchApproveOrRejectRegularizeAction: (
    data: ApproveAndRejectRegularizePayloadType
  ) => dispatch(approveOrRejectRegularizeAction(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ThinksToDo);
